export { default as VippsButton } from './vipps-button'
